import { classNames } from "./Utils/classNames.ts";

export function HorizontalLineDivider({ className }: { className?: string }) {
  return (
    <div className={classNames(className ?? "", "h-px w-full bg-slate-100")} />
  );
}
